import { TwoFactorSmsSetup } from "@/components/Portal/UserAccount/Security/Change/TwoFactorSmsSetup";

export const TwoFactorSetupSmsView = () => <TwoFactorSmsSetup />;
